import { api } from "app/data/api";

export const getUsersByProfile = async (profile: number) => {
  return await api.get(`/user/profile/${profile}`);
};

export const fetchGoogleDriveUrl = async () => {
  return await api.get(`/user/getUserDriveUrl`);
};

export const fetchUsersByManager = async (managerId: number) => {
  return await api.get(`/manageUser/listUserByManager/${managerId}`);
};

export type UserProfiles = UserProfile[];

export interface UserProfile {
  id: number;
  user_id: number;
  profile_id: number;
  active: number;
  department_id: number;
  created_at: string;
  updated_at: string;
  user: User;
}

export interface User {
  id: number;
  name: string;
  email: string;
  cpf: string;
  created_at: string;
  updated_at: string;
  active: number;
}
